var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4547_1804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 10C20.0001 10.6286 19.9372 11.2457 19.8115 11.84C19.7144 12.3314 19.5772 12.8057 19.3944 13.2629C19.2058 13.7657 18.9715 14.2457 18.6972 14.6971C17.1029 17.36 14.1886 19.1429 10.8572 19.1429H9.14293L8.34864 18.7829C4.52007 17.6914 1.71436 14.1771 1.71436 10C1.71436 5.82286 4.52007 2.30286 8.34864 1.21143L9.14293 0.857147H10.8572C13.4229 0.857147 15.7429 1.91429 17.3944 3.61715C18.0001 4.22858 18.5144 4.93143 18.9258 5.69143C19.3772 6.53715 19.7029 7.46858 19.8686 8.44572C19.9544 8.95429 20.0001 9.46858 20.0001 10Z",
    fill: "#CCF526"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.0001 10C20.0001 10.6286 19.9372 11.2457 19.8115 11.84C19.7144 12.3314 19.5772 12.8057 19.3944 13.2629C19.2058 13.7657 18.9715 14.2457 18.6972 14.6971C17.1029 17.36 14.1886 19.1429 10.8572 19.1429H9.14293L8.34864 18.7829C4.52007 17.6914 1.71436 14.1771 1.71436 10C1.71436 5.82286 4.52007 2.30286 8.34864 1.21143L9.14293 0.857147H10.8572C13.4229 0.857147 15.7429 1.91429 17.3944 3.61715C18.0001 4.22858 18.5144 4.93143 18.9258 5.69143C19.3772 6.53715 19.7029 7.46858 19.8686 8.44572C19.9544 8.95429 20.0001 9.46858 20.0001 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 10C20 10.6286 19.9372 11.2457 19.8115 11.84H17.8V8.44574H19.8686C19.9543 8.95431 20 9.4686 20 10Z",
    fill: "#CCF526"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.9257 5.69144H14.72V3.61716H17.3943C18 4.22859 18.5143 4.93144 18.9257 5.69144Z",
    fill: "#CCF526"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.3943 13.2629C19.2057 13.7657 18.9714 14.2457 18.6971 14.6972H15.5371V13.2629H19.3943Z",
    fill: "#CCF526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 19.1429C14.1923 19.1429 18.2857 15.0495 18.2857 10C18.2857 4.95054 14.1923 0.857147 9.14286 0.857147C4.0934 0.857147 0 4.95054 0 10C0 15.0495 4.0934 19.1429 9.14286 19.1429Z",
    fill: "#CCF526"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M9.14282 17.3943C13.2266 17.3943 16.5371 14.0838 16.5371 10C16.5371 5.91625 13.2266 2.60571 9.14282 2.60571C5.05907 2.60571 1.74854 5.91625 1.74854 10C1.74854 14.0838 5.05907 17.3943 9.14282 17.3943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M2.98282 10C2.98282 6.12571 5.96568 2.94857 9.75996 2.63428C9.55425 2.61714 9.35425 2.60571 9.14282 2.60571C5.05711 2.60571 1.74854 5.91428 1.74854 10C1.74854 14.0857 5.05711 17.3943 9.14282 17.3943C9.34854 17.3943 9.55425 17.3771 9.75996 17.3657C5.96568 17.0514 2.98282 13.88 2.98282 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26798 6.66666C6.00233 6.66666 4.97632 7.74271 4.97632 9.07007C4.97632 11.4735 7.68465 13.6584 9.14298 14.1667C10.6013 13.6584 13.3097 11.4735 13.3097 9.07007C13.3097 7.74271 12.2836 6.66666 11.018 6.66666C10.2429 6.66666 9.55771 7.07019 9.14298 7.68784C8.72826 7.07019 8.04305 6.66666 7.26798 6.66666Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4547_1804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinDark);
export default __webpack_public_path__ + "static/media/coin-dark.a485d037740ace1f8c85df1f93c7bba6.svg";
export { ForwardRef as ReactComponent };